// extracted by mini-css-extract-plugin
module.exports = {"jobApplicationIcon":"styles_jobApplicationIcon__2VDaG"};